import { useContext, useRef, useState } from "react";
import { ConversationContext, useEmailReply } from "../context";
import { TextInput } from "@interstate/components/TextInput";
import { replySubjectInputTestId } from "../testIds";
import { ConversationTypeEnum } from "@coxauto-ui/cxm/communications/interfaces";
import { InterstateOnChangeEvent } from "@interstate/components/InterstateEvents";
import { TextInputEventValue } from "@interstate/components/TextInput";
import styled from "styled-components";

const StyledSubjectWrapper = styled.div<{ $hasError: boolean }>`
  .MuiFormLabel-root {
    color: ${({ $hasError }) => ($hasError ? "#d32f2f" : "")} !important;
  }
  .MuiOutlinedInput-notchedOutline {
    border-color: ${({ $hasError }) => ($hasError ? "#d32f2f" : "")} !important;
  }
`;

export interface MessageSubjectInputProps {
  isDisabled: boolean;
}

export function MessageSubjectInput({ isDisabled }: MessageSubjectInputProps) {
  const { activeListTab } = useContext(ConversationContext);
  const { replyTextSubject, setReplyTextSubject } = useEmailReply();
  const [hasBlurred, setHasBlurred] = useState(false);

  const showError = hasBlurred && !replyTextSubject;

  const onInputChange = (
    event: InterstateOnChangeEvent<TextInputEventValue>
  ) => {
    setReplyTextSubject(event.target.value);
  };

  const onBlur = () => {
    setHasBlurred(true);
  };

  const inputRef = useRef<HTMLInputElement>(null);

  if (activeListTab !== ConversationTypeEnum.EMAIL.valueOf()) return <span />;

  return (
    <StyledSubjectWrapper $hasError={showError}>
      <TextInput
        autoComplete="off"
        data-testid={replySubjectInputTestId}
        disabled={isDisabled}
        id="conversation-reply-subject-input"
        label="Subject (required)"
        name="ConversationReplySubjectInput"
        ref={inputRef}
        value={replyTextSubject}
        onBlur={onBlur}
        onChange={onInputChange}
      />
    </StyledSubjectWrapper>
  );
}

export default MessageSubjectInput;
